import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { API_SCHEME, API_HOST, API_PATH } from 'utils/env';

export const baseURI = 'nominas/vacaciones-empleados-dias-disfrutados';

/**
 * GET Vacaciones Empleados Dias Disfrutados
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getVacacionesEmpleadosDiasDisfrutados = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Vacaciones Empleado Dias Disfrutados
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getVacacionesEmpleadoDiasDisfutados = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Vacaciones Empleado Dias Disfrutados
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postVacacionesEmpleadoDiasDisfutados = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Vacaciones Empleado Dias Disfrutados
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchVacacionesEmpleadoDiasDisfutados = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Vacaciones Empleado Dias Disfrutados
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteVacacionesEmpleadoDiasDisfutados = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET Vacaciones Plantilla Excel
 * @returns {Promise<object[]>}
 */
export const getVacacionesPlantillaExcel = async () => {
  try {
    const response = await API.get(`${API_SCHEME}://${API_HOST}${API_PATH}nominas/vacaciones-obtener-plantilla-excel`, {
      headers: {
        'Content-Type': 'application/ms-excel',
      },
      responseType: 'arraybuffer',
    });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};
